export default [
  {
    path: '/entrepreneur',
    name: 'entrepreneur',
    meta: { level: 'c2', title: '企业认证' },
    props: (route) => ({ params: route.params, query: route.query }),
    component: () => import('./main/index.vue')
  },
  {
    path: '/entrepreneurResult',
    name: 'entrepreneurResult',
    meta: { level: 'c2', title: '企业认证', report: { disable: true } },
    props: (route) => ({ params: route.params, query: route.query }),
    component: () => import('./main/result.vue')
  }
]
